import React, { useContext, useEffect, useState } from "react";

import MenuSide from "../components/menuSide";
import { Layout, theme, Tabs, Typography, Row, Col } from "antd";
import { CloudDownloadOutlined } from '@ant-design/icons';
import ListFanshineWithdraw from '../components/listFanshineWithdraw'
import { AppContext } from '../App';
import { MenuOutlined  } from '@ant-design/icons';


const { Title } = Typography;
const { Content } = Layout;

const fanshineWithdraw = () => {
  
  const { user } = useContext(AppContext);
  if(user){ 
    if(user.role !== 'admin'){      
      window.location.href = "/home"; 
    }
  }

  const [width, setWidth] = useState(window.innerWidth);
  const [menuDisplay, setMenuDisplay] = useState(false);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenu = (value) => {
    setMenuDisplay(value)
  }


    return (
      width < 1000 ? 
      <Layout className="fullHeight">
          {menuDisplay ? <MenuSide/> : <MenuOutlined onClick={()=>handleMenu(true)} style={{margin:20}}/>}
          <Content className="contentSection" onClick={()=>handleMenu(false)}>
          <Row>
                <Col span={24}><Title level={3}><CloudDownloadOutlined /> รายการเบิกเงิน</Title></Col>
            </Row>
            <Row>
                <Col span={24}><ListFanshineWithdraw /></Col>
            </Row>
          </Content>
          
      </Layout>
      :
      <Layout className="fullHeight">
          <MenuSide />
          <Content className='contentSection'>
          <Row>
                <Col span={1} />
                <Col span={22}><Title level={3}><CloudDownloadOutlined /> รายการเบิกเงิน</Title></Col>
                <Col span={1} />
            </Row>
            <Row>
                <Col span={1} />
                <Col span={22}><ListFanshineWithdraw /></Col>
                <Col span={1} />
            </Row>
          </Content>
          
      </Layout>
    )
  };
  
  export default fanshineWithdraw;
  